import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    paddingLeft: 0,
    '&.gap-8': {
      gap: '0.5rem',
    },
    '&.gap-12': {
      gap: '0.75rem',
    },
    '&.gap-16': {
      gap: '1rem',
    },
    '&.gap-24': {
      gap: '1.5rem',
    },
  },
}));
